module.exports = __webpack_public_path__ + "img/dfBg.c1bdb142.png";